import React from 'react'
import styles from "./index.module.scss"
import HeroImage from '../../assets/hero2.jpg'
import HeroImage2 from '../../assets/ch-hero2.jpg'
import Slider1 from '../../assets/slider-images/slider1.jpg'
import Slider2 from '../../assets/slider-images/slider2.jpg'
import Slider3 from '../../assets/slider-images/slider3.jpg'
import Slider4 from '../../assets/slider-images/slider4.jpg'
import Slider5 from '../../assets/slider-images/slider5.jpg'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const ImageSlider = () => {

    const images = [
        {
            id:5,
            image:Slider3
        },
        {
            id:1,
            image:HeroImage
        },
        {
            id:2,
            image:HeroImage2
        },
        {
            id:3,
            image:Slider1
        },
        {
            id:4,
            image:Slider2
        },
        {
            id:6,
            image:Slider4
        },
        {
            id:7,
            image:Slider5
        },
    ]

  return (
    <Carousel 
        showThumbs={false} 
        autoPlay={true} 
        interval={5000} 
        transitionTime={1000}
        infiniteLoop={false}
        showArrows={false}
        showIndicators={true}
        showStatus={false}
        stopOnHover={false}
        swipeable={true}>
            {
                images.map((item) => {
                    return(
                        <div key={item.id} className={styles.image_ctn}>
                            <img src={item.image} alt="" />
                        </div>
                    )
                })
            }
    </Carousel>
  )
}

export default ImageSlider